export const SHOW_LOGO = false // 是否显示logo
export const SHOW_LOGIN_DESC = false // 是否显示登录描述
export const SHOW_FOOTER = false // 是否显示footer
export const SHOW_FORGOT_PASSWORD = false // 是否显示忘记密码
export const SHOW_PUBLISH_TAB = false // 是否显示布置作业的下面的tabs
